import { useState, useEffect, useRef } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import OrganizationPicker from '../../components/OrganizationPicker';
import OrganizationFilter from '../../components/OrganizationFilter';
import LabeledSelectionCheckbox from '../../components/LabeledSelectionCheckbox';
import { ventrisConfig } from '../../ventris.config';
import { focusFirstInvalidField } from '../../accessibility/focus';

import GroupPageIcon from '../../icons/GroupPageIcon';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import GroupIcon from '../../icons/GroupIcon';
import { getUseCaseTerminology } from '../../useCase';

type ClinicianGroupsProps = {
};

let searchDebounce: any = null;

function ClinicianGroups({}: ClinicianGroupsProps) {
  const terms = getUseCaseTerminology();
  const [user, setUser] = useState([] as any);
  const [organizations, setOrganizations] = useState([] as any);
  const [students, setStudents] = useState([] as any);
  const [groups, setGroups] = useState([] as any);
  const [selectedGroup, setSelectedGroup] = useState({} as any);
  const [selectedGroupId, setSelectedGroupId] = useState("" as any);
  const [selectedGroupIds, setSelectedGroupIds] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [errorCreate, setErrorCreate] = useState("");
  const [validatedCreate, setValidatedCreate] = useState(false);

  const [groupName, setGroupName] = useState("");
  const [groupStudents, setGroupStudents] = useState([] as any);
  const [organizationId, setOrganizationId] = useState("");

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [search, setSearch] = useState("");

  const editFormRef = useRef(null as any);
  const createFormRef = useRef(null as any);

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    let currentUser = sessionStorage.getItem("current_user");
    setUser(JSON.parse(currentUser!));
    setOrganizationId(JSON.parse(currentUser!).organization_id);
    
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
      loadGroups(1);
    });

    fetch(ventrisConfig.url + '/api/students?sizePerPage=1000', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setStudents(data.students);
    });
  }, []);

  useEffect(() => {
      loadGroups(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, archivedFilter]);
  
  useEffect(() => {
    if (searchDebounce) {
      clearTimeout(searchDebounce);
    }

    searchDebounce = setTimeout(() => {
      setPage(1);
      loadGroups(1);
    }, 500);
  }, [search]);

  const loadGroup = (groupId: any) => {
    document.location.href = "/group/" + groupId;
  }

  const loadGroups = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/groups?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&archived=' + archivedFilter + '&search=' + search, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setGroups(data.groups);
        setTotalSize(data.total_records);
      });
    },
    100);
  }

  const editGroup = (group: any) => {
    const studentsInGroup: any = [];
    for (let i = 0; i < group.student_groups?.length; i++) {
      studentsInGroup.push(group.student_groups[i].student_id.toString());
    }
    console.log(studentsInGroup);

    setSelectedGroup(group);
    setSelectedGroupId(group.id);
    setGroupName(group.name);
    setGroupStudents(studentsInGroup);
    setOrganizationId(group.organization_id);
    setShowEditModal(true);
  }

  const handleEditSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedEdit(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedEdit(true);
        setErrorEdit("");

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/group/' + selectedGroup.id, {
          method: 'put',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            name: groupName,
            students: groupStudents.join("|"),
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowEditModal(false);
            setPage(1);
            loadGroups(1);
          } else {
            setErrorEdit("An error occured while editing this group. Please try again!");
          }
        });
    }
  };

  const createGroup = () => {
    setSelectedGroup({});
    setSelectedGroupId(-1);
    setGroupName("");
    setGroupStudents([]);
    setOrganizationId(user.organization_id);
    setShowCreateModal(true);
  }

  const handleCreateSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedCreate(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedCreate(true);
        setErrorCreate("");

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/group', {
          method: 'post',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            name: groupName,
            students: groupStudents.join("|"),
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowCreateModal(false);
            setPage(1);
            loadGroups(1);
          } else {
            setErrorCreate("An error occured while creating this group. Please try again!");
          }
        });
    }
  };

  const actuallyDeleteGroups = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/group/delete', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        groups: selectedGroupIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      fetch(ventrisConfig.url + '/api/groups', {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
        }).then(async function (data) {
        setShowDeleteModal(false);
        setShowArchiveModal(false);
        setPage(1);
        loadGroups(1);
      });
    });
  }

  const actuallyArchiveGroups = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/group/' + (archivedFilter === 'true' ? 'unarchive' : 'archive'), {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        groups: selectedGroupIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadGroups(1);
    });
  }

  const toggleSelectedGroup = (groupId: string | number) => {
    const normalizedId = String(groupId);
    setSelectedGroupIds((prev: any) =>
      prev.includes(normalizedId)
        ? prev.filter((item: any) => item !== normalizedId)
        : [...prev, normalizedId]
    );
  }

  const toggleSelectedStudent = (studentId: string) => {
    if (groupStudents.includes(studentId)) {
      let updatedSelectedTestIds = JSON.parse(JSON.stringify(groupStudents));
      updatedSelectedTestIds = updatedSelectedTestIds.filter((item: any) => item !== studentId);
      setGroupStudents(updatedSelectedTestIds);
    } else {
      const updatedSelectedTestIds = JSON.parse(JSON.stringify(groupStudents));
      updatedSelectedTestIds.push(studentId);
      console.log(updatedSelectedTestIds);
      setGroupStudents(updatedSelectedTestIds);
    }
  }

  const checkboxFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
    const { selectedGroupIds, toggleSelectedGroup } = formatExtraData;
    return <LabeledSelectionCheckbox
      id={`group-select-${row.id}`}
      label={`Select ${row.name}`}
      checked={selectedGroupIds.includes(String(row.id))}
      onChange={() => toggleSelectedGroup(row.id)}
    />;
  }

  const groupNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <span aria-hidden="true" className={row.archived ? "ventris-table-status-archived" : "ventris-table-status-completed"}></span>
        <span className="visually-hidden">{row.archived ? "Archived: " : "Active: "}</span>
        <Button variant="link" size="sm" onClick={() => loadGroup(row.id)}>{cell}</Button>
      </div>
    );
  }

  const dateFormatter = (cell: any, row: any) => {
    return (
      <div>
        {(new Date(Date.parse(cell))).toLocaleDateString()}
      </div>
    );
  }

  const actionFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => editGroup(row)}>Edit</Button>
      </div>
    );
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Select',
      headerFormatter: () => <span className="visually-hidden">Select groups</span>,
      formatter: checkboxFormatter,
      formatExtraData: { selectedGroupIds, toggleSelectedGroup }
    },
    {
      dataField: 'name',
      text: 'Group Name',
      sort: true,
      formatter: groupNameFormatter
    },
    {
      dataField: 'student_count',
      text: 'Number of Students',
    },
    {
      dataField: 'created_at',
      text: 'Date Added',
      formatter: dateFormatter
    },
    {
      dataField: 'organization',
      text: 'Organization',
      sort: true
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: actionFormatter
    }
  ];

  const handleTabChange = (tabKey: string | null) => {
    if (tabKey === 'view-all') {
      setArchivedFilter("");
    } else if (tabKey === 'active') {
      setArchivedFilter("false");
    } else if (tabKey === 'archived') {
      setArchivedFilter("true");
    }
    setPage(1);
  }

  const updateFilter = (organizations: any) => {
    setOrganizationFilter(organizations.join('|'));
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setPage(page);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  return (
    <Container fluid className="ventris-content-wrapper ventris-groups">
      <Header portal={sessionStorage.getItem("portal")!} page="groups" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header align-items-center">
              <GroupPageIcon />
              <div className="flex-grow">Groups</div>
              <Form.Control type="search" className="ventris-search" aria-label="Search groups" placeholder="Search groups" value={search} onChange={(event) => setSearch(event.target.value)} />
              <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal" onClick={() => createGroup()}><GroupIcon /> Add a Group</Button>
            </h1>
            <div className={showFilters ? '' : 'hidden'}>
              <OrganizationFilter updateFilter={updateFilter} />
            </div>
            <div className="flex flex-row">
              <div className="flex-grow">
                <Tabs defaultActiveKey="view-all" onSelect={(event) => handleTabChange(event)}>
                  <Tab eventKey="view-all" title="View All">
                  </Tab>
                  <Tab eventKey="active" title="Active">
                  </Tab>
                  <Tab eventKey="archived" title="Archived">
                  </Tab>
                </Tabs>
              </div>
              <div className="ventris-action-links">
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowArchiveModal(true)}><ArchiveIcon /> {archivedFilter === 'true' ? 'Unarchive' : 'Archive'} Selected</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowDeleteModal(true)}><DeleteIcon /> Delete Selected</Button>
              </div>
            </div>
            <ResponsiveTableRegion label="Groups">
              <BootstrapTable keyField='id' data={groups} columns={columns} bordered={true} remote={{pagination: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} />
            </ResponsiveTableRegion>
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these item(s)? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => actuallyArchiveGroups()}>No, Archive Instead</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteGroups()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to {archivedFilter === 'true' ? 'unarchive' : 'archive'} these item(s)?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowArchiveModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyArchiveGroups()}>Yes, Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showEditModal} onHide={() => setShowEditModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="edit-group-title">
          <Offcanvas.Header className="offcanvas-header-blue" closeButton>
              <Offcanvas.Title id="edit-group-title">Edit Group</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-group-form" validated={validatedEdit} ref={editFormRef} onSubmit={handleEditSubmit}>
                {errorEdit != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorEdit}
                </div> : null}
                <Form.Group className="mb-3" controlId="edit-group-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={organizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-group-name">
                    <Form.Label>Group Name:</Form.Label>
                    <Form.Control required type="text" placeholder="Group Name" value={groupName} onChange={(event) => setGroupName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a group name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-group-students">
                    <Form.Label>{terms.students}:</Form.Label>
                    <div className="group-student-wrapper">
                      {students.map((student: any) => 
                        <div key={student.id}>
                          <input type="checkbox" id={`edit-group-student-${student.id}`} checked={groupStudents.includes(student.id.toString())} onChange={() => toggleSelectedStudent(String(student.id))} /> <label htmlFor={`edit-group-student-${student.id}`}>{student.last_name}, {student.first_name} ({student.student_code})</label>
                        </div>
                      )}
                    </div>
                </Form.Group>
                <br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Save Changes</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showCreateModal} onHide={() => setShowCreateModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="create-group-title">
          <Offcanvas.Header className="offcanvas-header-blue" closeButton>
              <Offcanvas.Title id="create-group-title">Create Group</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-group-form" validated={validatedCreate} ref={createFormRef} onSubmit={handleCreateSubmit}>
                {errorCreate != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorCreate}
                </div> : null}
                <Form.Group className="mb-3" controlId="create-group-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={organizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-group-name">
                    <Form.Label>Group Name:</Form.Label>
                    <Form.Control required type="text" placeholder="Group Name" value={groupName} onChange={(event) => setGroupName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a group name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-group-students">
                    <Form.Label>{terms.students}:</Form.Label>
                    <div className="group-student-wrapper">
                      {students.map((student: any) => 
                        <div key={student.id}>
                          <input type="checkbox" id={`create-group-student-${student.id}`} checked={groupStudents.includes(student.id.toString())} onChange={() => toggleSelectedStudent(String(student.id))} /> <label htmlFor={`create-group-student-${student.id}`}>{student.last_name}, {student.first_name} ({student.student_code})</label>
                        </div>
                      )}
                    </div>
                </Form.Group>
                <br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Create Group</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default ClinicianGroups;
